import { useExtraConfigContext } from '@gov-nx/core/app';

export const useEnvironment = () => {
	const {
		extraConfig: { environment },
	} = useExtraConfigContext();

	return {
		isLocalhost: environment === 'lcl',
	};
};
